export default __webpack_public_path__ + "static/media/LogoMaccaferri.d857fb74.svg";